const PREFERRED_COLOR_SCHEME_KEY = 'prefers_color_scheme';
const MODAL_DEPOSIT_HASH = '#modal-deposit';

export function initPaymentModal() {
  removeGameModalDeposit();

  window.addEventListener('game_window', handleGameWindowEvent);
}

function handleGameWindowEvent(e) {
  if (e.detail.state) {
    initGameModalDeposit();
  } else {
    removeGameModalDeposit();
  }
}

export function removeGameModalDeposit() {
  setTimeout(() => {
    sessionStorage.removeItem(PREFERRED_COLOR_SCHEME_KEY);

    if (location.hash === MODAL_DEPOSIT_HASH) {
      location.hash = '';
    }
  }, 100);
}

export function initGameModalDeposit() {
  sessionStorage.setItem(PREFERRED_COLOR_SCHEME_KEY, 'game');
}
